import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Datafeed from './api/';

class TradingViewComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      symbol: props.s,
      ticker: props.t,
    };
  }

  componentDidMount() {
    const cookies = new Cookies();
    let fSym = this.state.symbol || cookies.get('fSym') || 'BTCUSDT';
    let fRes = this.state.ticker || cookies.get('fRes') || 60;
    let points = [];

    // window.TradingView.onready(() => {
    const widget = (window.tvWidget = new TradingView.widget({
      // debug: false,
      fullscreen: true,
      library_path: '/charting_library/',
      symbol: fSym,
      interval: fRes,
      timezone: 'Asia/Taipei',
      container_id: 'tv_chart_container',
      locale: 'zh_TW',
      theme: 'Dark',
      datafeed: new Datafeed(),
      disabled_features: [
        'header_chart_type',
        'header_compare',
        'header_undo_redo',
        'header_settings',
        'header_screenshot',
      ],
      overrides: {
        'mainSeriesProperties.candleStyle.drawBorder': false,
        // "mainSeriesProperties.style": 1, //k线图
        'paneProperties.background': '#333', //背景色
        'paneProperties.vertGridProperties.color': '#333', //垂直分割线
        'paneProperties.horzGridProperties.color': '#555', //水平分割线
        // "paneProperties.horzGridProperties.style": 3,//solid = 0; dotted = 1; dashed = 2; large dashed = 3
        // "paneProperties.legendProperties.showSeriesTitle": false,//图表标题
        'mainSeriesProperties.candleStyle.upColor': '#666', //蜡烛图阳线颜色
        'mainSeriesProperties.candleStyle.downColor': '#666', //蜡烛图阴线颜色
        'mainSeriesProperties.candleStyle.borderUpColor': '#666', //阳线边框颜色
        'mainSeriesProperties.candleStyle.borderDownColor': '#666', //阴线边框颜色
        'mainSeriesProperties.candleStyle.wickUpColor': '#666', //阳线的影线颜色
        'mainSeriesProperties.candleStyle.wickDownColor': '#666', //阴线的影线颜色
        // 'mainSeriesProperties.showPriceLine': false, // 是否显示当前价格线
      },
      studies_overrides: {
        'macd.macd.color': '#80c6f9',
        'macd.signal.color': '#f79465',
        'macd.histogram.plottype': 'columns',
        // 'volume.volume.color.0': 'rgba(47,168,59,0.6)', //阴线对应成交量颜色
        // 'volume.volume.color.1': 'rgba(158,0,3,0.6)', //阳线对应成交量颜色
        // 'bollinger bands.plots background.color': 'rgba(10,10,10,0)', // 布林带的区域快颜色
        // 'bollinger bands.upper.color': '#026602', // 上线颜色
        // 'bollinger bands.median.color': 'rgba(10,10,10,0)', // 中线颜色
        // 'bollinger bands.lower.color': '#026602', // 下线颜色
      },
      custom_indicators_getter: function (PineJS) {
        return Promise.resolve([
          {
            name: 'Bar Colorer Demo',
            metainfo: {
              _metainfoVersion: 42,

              id: 'BarColoring@tv-basicstudies-1',

              name: 'BarColoring',
              description: 'Bar Colorer Demo',
              shortDescription: 'JR Index',
              scriptIdPart: '',
              is_price_study: true,
              is_hidden_study: false,
              isCustomIndicator: true,
              defaults: {
                precision: 4,
                palettes: {
                  palette_0: {
                    // 调色板颜色
                    // 将其更改为您喜欢的默认颜色，
                    // 但请注意，用户可以在“样式”选项卡中更改它们
                    // 指标属性
                    colors: [{ color: '#4caf50' }, { color: '#ffeb3a' }, { color: '#ef5250' }],
                  },
                },
              },
              inputs: [],
              plots: [
                {
                  id: 'plot_0',

                  // plot类型应设置为 'bar_colorer'
                  type: 'bar_colorer',

                  // 这是定义的调色板的名称
                  // 在 'palettes' 和 'defaults.palettes' 部分
                  palette: 'palette_0',
                },
              ],
              palettes: {
                palette_0: {
                  colors: [{ name: 'long' }, { name: 'normal' }, { name: 'short' }],

                  // 值之间的映射
                  // 返回脚本和调色板颜色
                  valToIndex: {
                    1: 0,
                    2: 1,
                    3: 2,
                  },
                },
              },
            },
            constructor: function () {
              this.f_1 = function (src, len, ctx) {
                var series_0 = ctx.new_var(PineJS.Std.max(PineJS.Std.change(src), 0));
                return PineJS.Std.rma(series_0, len, ctx);
              };

              this.f_2 = function (src, len, ctx) {
                var series_0 = ctx.new_var(-PineJS.Std.min(PineJS.Std.change(src), 0));
                return PineJS.Std.rma(series_0, len, ctx);
              };

              this.main = function (context, input) {
                this._context = context;
                this._input = input;

                let src = PineJS.Std.open(this._context);
                let src2 = PineJS.Std.close(this._context);
                let open = this._context.new_var(src);
                let close = this._context.new_var(src2);

                let ema05 = this._context.new_var(PineJS.Std.ema(open, 5, this._context));
                let ma05 = ema05.get(0);
                let bma05 = ema05.get(1);

                let ema10 = this._context.new_var(PineJS.Std.ema(open, 10, this._context));
                let ma10 = ema10.get(0);
                let bma10 = ema10.get(1);

                let ema15 = this._context.new_var(PineJS.Std.ema(open, 15, this._context));
                let ma15 = ema15.get(0);
                let bma15 = ema15.get(1);

                let ema20 = this._context.new_var(PineJS.Std.ema(open, 20, this._context));
                let ma20 = ema20.get(0);
                let bma20 = ema20.get(1);

                let ema25 = this._context.new_var(PineJS.Std.ema(open, 25, this._context));
                let ma25 = ema25.get(0);
                let bma25 = ema25.get(1);

                let ema30 = this._context.new_var(PineJS.Std.ema(open, 30, this._context));
                let ma30 = ema30.get(0);
                let bma30 = ema30.get(1);

                let ema35 = this._context.new_var(PineJS.Std.ema(open, 35, this._context));
                let ma35 = ema35.get(0);
                let bma35 = ema35.get(1);

                let ema40 = this._context.new_var(PineJS.Std.ema(open, 40, this._context));
                let ma40 = ema40.get(0);
                let bma40 = ema40.get(1);

                let ema45 = this._context.new_var(PineJS.Std.ema(open, 45, this._context));
                let ma45 = ema45.get(0);
                let bma45 = ema45.get(1);

                let ema50 = this._context.new_var(PineJS.Std.ema(open, 50, this._context));
                let ma50 = ema50.get(0);
                let bma50 = ema50.get(1);

                let ema55 = this._context.new_var(PineJS.Std.ema(open, 55, this._context));
                let ma55 = ema55.get(0);
                let bma55 = ema55.get(1);

                let ema60 = this._context.new_var(PineJS.Std.ema(open, 60, this._context));
                let ma60 = ema60.get(0);
                let bma60 = ema60.get(1);

                let ema65 = this._context.new_var(PineJS.Std.ema(open, 65, this._context));
                let ma65 = ema65.get(0);
                let bma65 = ema65.get(1);

                let ema70 = this._context.new_var(PineJS.Std.ema(open, 70, this._context));
                let ma70 = ema70.get(0);
                let bma70 = ema70.get(1);

                let overSold = 40;
                let overBought = 60;
                let vrsi = PineJS.Std.rsi(this.f_1(close, 14, this._context), this.f_2(close, 14, this._context));

                let result = 2;
                var bar_time = new Date(PineJS.Std.time(this._context));
                var point = {
                  time: bar_time.getTime() / 1000,
                };
                var options = {
                  // lock: true,
                  shape: 'arrow_up',
                  zOrder: 'top',
                  text: 'L',
                  disableSelection: true,
                  disableUndo: true,
                  overrides: {
                    color: '#4caf50',
                  },
                };
                var options2 = {
                  // lock: true,
                  shape: 'arrow_down',
                  zOrder: 'top',
                  text: 'S',
                  disableSelection: true,
                  disableUndo: true,
                  overrides: {
                    color: '#ef5250',
                  },
                };
                let last_result = context.new_var(result);
                if (
                  ma05 >= bma05 &&
                  ma10 >= bma10 &&
                  ma15 >= bma15 &&
                  ma20 >= bma20 &&
                  ma25 >= bma25 &&
                  ma30 >= bma30 &&
                  ma35 >= bma35 &&
                  ma40 >= bma40 &&
                  ma45 >= bma45 &&
                  ma50 >= bma50 &&
                  ma55 >= bma55 &&
                  ma60 >= bma60 &&
                  vrsi > overBought
                ) {
                  result = 1;
                  last_result.set(1);
                } else if (
                  ma05 <= bma05 &&
                  ma10 <= bma10 &&
                  ma15 <= bma15 &&
                  ma20 <= bma20 &&
                  ma25 <= bma25 &&
                  ma30 <= bma30 &&
                  ma35 <= bma35 &&
                  ma40 <= bma40 &&
                  ma45 <= bma45 &&
                  ma50 <= bma50 &&
                  ma55 <= bma55 &&
                  ma60 <= bma60 &&
                  ma65 <= bma65 &&
                  ma70 <= bma70 &&
                  vrsi < overSold
                ) {
                  result = 3;
                  last_result.set(3);
                } else {
                  result = last_result.get(1);
                  last_result.set(result);
                }

                // console.log(close.get(0))
                if (result == 1 && last_result.get(1) == 3 && !points.includes(point.time)) {
                  // last_result.set(1);
                  // result = 1;
                  widget.chart().createShape(point, options);
                  points.push(point.time);
                  // console.log(point);
                } else if (result == 3 && last_result.get(1) == 1 && !points.includes(point.time)) {
                  // last_result.set(3);
                  // result = 3;
                  widget.chart().createShape(point, options2);
                  points.push(point.time);
                  // console.log(point);
                }

                return [result];
              };
            },
          },
        ]);
      },
    }));
    widget.onChartReady(() => {
      // console.log('Chart has loaded!');
      widget
        .chart()
        .onSymbolChanged()
        .subscribe(null, () => {
          // widget.activeChart().removeAllShapes();
          // console.log(widget.activeChart().getVisibleRange());
          // console.log('symbol:');
          // console.log(widget.activeChart().symbol());
        });
      widget
        .chart()
        .onIntervalChanged()
        .subscribe(null, (interval, timeframeObj) => {
          // console.log(interval);
          widget.chart().removeAllShapes();
          points = [];
          // console.log('removeshapes');
          // console.log(widget.activeChart().getVisibleRange());
          // console.log('symbol:');
          // console.log(widget.activeChart().symbol());
        });
      widget
        .activeChart()
        .onVisibleRangeChanged()
        .subscribe(null, ({ from, to }) => {
          // widget.chart().removeAllShapes();
        });
      widget
        .activeChart()
        .onDataLoaded()
        .subscribe(null, () => {
          console.log('onDataLoaded');
          widget.chart().removeAllShapes();
        });
      widget.chart().createStudy('Bar Colorer Demo', true, true);
      widget.chart().createStudy('MACD', false, false, [12, 26, 'close', 9]);
    });
    widget.headerReady().then(function () {
      function createHeaderButton(text, title, clickHandler, options) {
        var button = widget.createButton(options);
        button.setAttribute('title', title);
        button.textContent = text;
        button.addEventListener('click', clickHandler);
      }

      createHeaderButton('設為預設圖表', '設為預設圖表', function () {
        alert('Saved');
        cookies.set('fSym', widget.activeChart().symbol(), { path: '/' });
        cookies.set('fRes', widget.activeChart().resolution(), { path: '/' });
      });

      createHeaderButton('設定推播', '設定推播', function () {
        window.location.href = 'https://fuly.ai/trackings';
      });

      createHeaderButton('即時進場訊號', '即時進場訊號', function () {
        window.location.href = 'https://fuly.ai/jrb/dashboard';
      });
    });
    // });
  }

  render() {
    return <div id="tv_chart_container"></div>;
  }
}
export default TradingViewComponent;
